import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './assets/fonts/pluss60-icons/pluss60IconStyles.css';
import App from './App';
import { unregister } from './registerServiceWorker';
import { library, config } from '@fortawesome/fontawesome-svg-core';
import { faMobileAlt, faDesktop } from '@fortawesome/free-solid-svg-icons';
import { AuthStrategy } from './session/authentication';
import '@fortawesome/fontawesome-svg-core/styles.css';

config.autoAddCss = false;
library.add(faMobileAlt, faDesktop);

ReactDOM.render(
  <AuthStrategy.AuthProvider>
    <App />
  </AuthStrategy.AuthProvider>,
  document.getElementById('root'),
);
unregister();
